<template>
  <div
    data-test="client-settings"
    success-tag="client-settings"
  >
    <a
      v-tooltip.bottom="$t('client.labels.goToSettings')"
      @click="toggle"
    >
      <FontAwesomeIcon
        aria-controls="overlay_menu"
        aria-haspopup="true"
        class="has-text-white"
        :icon="['far', 'gear']"
      />
    </a>
    <PMenu
      id="overlay_menu"
      ref="menu"
      :model="items"
      :popup="true"
    >
      <template #item="{ item, props }">
        <div
          v-if="!item.route"
          class="m-0 rounded-tl-none rounded-tr-none bg-surface-0 px-5 py-2 font-bold text-surface-700"
        >
          {{ item.label }}
        </div>
        <AppLink
          v-else
          hide_underline
          :to="{ name: item.route }"
        >
          <div
            v-ripple
            :data-test="item.data_test"
            v-bind="props.action"
          >
            <span>{{ $t(`${item.label}`) }}</span>
          </div>
        </AppLink>
      </template>
    </PMenu>
  </div>
</template>

<script>
import { Employee, PROFILE_TYPES } from '@/app/data/model_constants';
import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import { mapGetters } from 'vuex';
import { useMqService } from '@/plugins/mq';

export default {
  name: 'TheClientSettingsNavbar',
  setup() {
    const mq = useMqService();
    return { mq };
  },
  data() {
    return {
      ROUTES_EMPLOYEES,
      PROFILE_TYPES,
    };
  },

  computed: {
    ...mapGetters(['current_profile', 'current_client']),

    is_maintainer() {
      return this.current_profile.attributes.role === Employee.ROLE_MAINTAINER;
    },

    items() {
      const items = [{ label: this.current_client.attributes.name }];

      if (!this.is_maintainer) {
        items.push({ label: 'navbar.topnavbar.company', route: ROUTES_EMPLOYEES.CLIENT_COMPANY, data_test: 'admin' });
      }

      items.push({ label: 'navbar.topnavbar.team', route: ROUTES_EMPLOYEES.SETTINGS_TEAM, data_test: 'team' });

      return items;
    },
  },

  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
  },
};
</script>
